import { motion } from "framer-motion";

import { Section } from "@/components/common/Section";
import { Container } from "@/components/common/Container";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Counter } from "@/components/common/Counter";

import { whyChooseUs } from "@/data/faq.data";
import { stats } from "@/data/home.data";

import {
  staggerContainer,
  fadeUp,
  viewportOnce,
} from "@/animations/motion";

/**
 * Why Choose Us
 * Business-focused differentiators.
 */
export function WhyChooseUs() {
  return (
    <Section id="why-us">
      <Container>
        <SectionHeading
          eyebrow="Why Choose VibeWell"
          title="A Technology Partner Focused on Business Outcomes"
          description="We combine technical expertise, modern engineering practices and a long-term partnership mindset to help organisations build secure, scalable and future-ready digital solutions."
        />

        <motion.div
          variants={staggerContainer(0.06, 0.08)}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3"
        >
          {whyChooseUs.map(({ title, description, icon: Icon }) => (
            <motion.div
              key={title}
              variants={fadeUp}
              className="group relative rounded-[1.5rem] border border-border bg-card p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary/25 hover:shadow-xl"
            >
              <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary transition-all duration-300 group-hover:bg-primary group-hover:text-primary-foreground">
                <Icon className="h-6 w-6" />
              </div>

              <h3 className="mt-5 font-heading text-lg font-semibold">
                {title}
              </h3>

              <p className="mt-3 text-sm leading-7 text-muted-foreground">
                {description}
              </p>
            </motion.div>
          ))}
        </motion.div>

        <div className="mt-12 rounded-[1.75rem] border border-border bg-card p-2 shadow-sm">
          <div className="grid grid-cols-2 gap-2 lg:grid-cols-4">
            {stats.map((item) => (
              <div
                key={item.label}
                className="rounded-2xl bg-background p-8 text-center"
              >
                {/* <Counter
                  value={item.value}
                  className="font-heading text-4xl font-bold tracking-tight text-primary"
                /> */}

                <p className="font-heading text-4xl font-bold tracking-tight text-primary">
                  {item.value}
                </p>

                <p className="mt-3 text-sm font-medium text-muted-foreground">
                  {item.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </Section>
  );
}